var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMethodPaymentTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5407_37208)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5407_37208)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 5.94971,
    width: 5.5,
    height: 4.08,
    rx: 1,
    stroke: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 3.00342,
    width: 9.625,
    height: 13.4867,
    rx: 2,
    stroke: "#2C2E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1.18994V4.21216H2.75V1.18994L3.4375 1.9455L4.125 1.18994L4.8125 1.9455L5.5 1.18994L6.1875 1.9455L6.875 1.18994L7.5625 1.9455L8.25 1.18994Z",
    fill: "white",
    stroke: "#2C2E30",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0625 4.58984H8.9375",
    stroke: "#2C2E30",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 11.2539,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.01172,
    y: 11.2539,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.45312,
    y: 11.2539,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 12.6821,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.01172,
    y: 12.6821,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.45312,
    y: 12.6821,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 14.042,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.01172,
    y: 14.042,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.45312,
    y: 14.042,
    width: 1.03125,
    height: 1.02,
    rx: 0.51,
    fill: "#2C2E30"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5407_37208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 17,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5407_37208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.32,
    fill: "white",
    transform: "translate(-2.75 0.680176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethodPaymentTerminal);
export default __webpack_public_path__ + "static/media/payment_method_payment_terminal.3da8c54f.svg";
export { ForwardRef as ReactComponent };